import React from 'react';
import GatsbyImage from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';

const Img = props => {
  const data = useStaticQuery(graphql`
    query ImageQuery {
      placeholder: imageSharp(
        fluid: { originalName: { regex: "/no-image/" } }
      ) {
        fluid(maxWidth: 1080, quality: 90) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  `);

  const { fluid } = props;
  const { placeholder } = data;
  const imgData = fluid ? props : placeholder;

  return <GatsbyImage {...imgData} />;
};

export default Img;
